
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/benefits/rakeback",
      function () {
        return require("private-next-pages/benefits/rakeback/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/benefits/rakeback"])
      });
    }
  